import { render, staticRenderFns } from "./OrgSelect.vue?vue&type=template&id=e29b4104&scoped=true&"
import script from "./OrgSelect.vue?vue&type=script&lang=js&"
export * from "./OrgSelect.vue?vue&type=script&lang=js&"
import style0 from "./OrgSelect.vue?vue&type=style&index=0&id=e29b4104&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e29b4104",
  null
  
)

export default component.exports